export function photoOnResize() {

    function photoResize() {
        const photo = $(".photo-on-resize .photo");
        photo.each(function () {
            let $thisPhoto = $(this);
            let desktopSrc = $thisPhoto.data("desktop-photo");
            let mobileSrc = $thisPhoto.data("mobile-photo");
            if (window.innerWidth >= 660) {
                $thisPhoto.css("background-image", "url(" + desktopSrc + ")");
            } else {
                if (mobileSrc) {
                    $thisPhoto.css("background-image", "url(" + mobileSrc + ")");
                } else {
                    $thisPhoto.css("background-image", "url(" + desktopSrc + ")");
                }
            }
        });
    }

    $(window).on("load resize", function () {
        photoResize();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/photoOnResize.js